module.exports = __webpack_public_path__ + "static/img/world-map.fe1ff32a.jpg";